export { CollapseDirective } from './collapse.directive';
export { CollapseModule } from './collapse.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/collapse/index.js
// module id = 806
// module chunks = 4